// open notifications either with url parameters or attribute
// the logic is to look in your html for an ID and display the text in data-notificationcontent like so:
//<script id="copy-confirmation" data-notificationcontent="Der Link wurde kopiert!" data-notificationvariant="success" data-notificationicon="thumb-up"></script>
export function notification() {
    const url: URL = new URL(window.location.href);
    const notificationEventOjects: NodeList | null = document.querySelectorAll(
        "[data-notification-event]",
    ) as NodeList;
    const closeButtons = document.querySelectorAll<HTMLElement>(".close");

    // close button
    if (closeButtons.length > 0) {
        closeButton(closeButtons);
    }

    // make notifications possible with click event on element with attribute like data-notification-event="IDtoLookForInHTML"
    if (notificationEventOjects.length > 0) {
        for (let i: number = 0; i < notificationEventOjects.length; i++) {
            notificationEventOjects[i].addEventListener("click", function (e) {
                const eventTarget: HTMLElement = e.target as HTMLElement;
                const notificationContentId: string = eventTarget.getAttribute(
                    "data-notification-event",
                ) as string;
                const notificationContent: string | undefined =
                    document.getElementById(String(notificationContentId))
                        ?.dataset.notificationcontent;
                const notificationVariant: string | undefined =
                    document.getElementById(String(notificationContentId))
                        ?.dataset.notificationvariant;
                if (!notificationContent) {
                    return;
                }
                notify(notificationContent, notificationVariant);
            });
        }
    }

    // make notifications possible with url parameters like: example.de/?notification=IDtoLookForInHTML
    if (hasQueryParams(url["href"])) {
        const params: URLSearchParams = new URLSearchParams(url.search);

        if (params.has("notification")) {
            const notificationContent: string | undefined =
                document.getElementById(String(params.getAll("notification")))
                    ?.dataset.notificationcontent;
            const notificationVariant: string | undefined =
                document.getElementById(String(params.getAll("notification")))
                    ?.dataset.notificationvariant;
            if (!notificationContent) {
                return;
            }
            window.onload = function () {
                notify(notificationContent, notificationVariant);
            };
        }
    }

    function closeButton(closeButtons: NodeListOf<HTMLElement>) {
        closeButtons.forEach((closeButton) => {
            closeButton.addEventListener("click", function () {
                const notifications =
                    document.getElementsByClassName("notification-popup");
                while (notifications.length > 0) {
                    const notification: Node = notifications[0]
                        .parentNode as Node;
                    if (notification) {
                        notification.removeChild(notifications[0]);
                    }
                }
            });
        });
    }

    // Always escape HTML for text arguments!
    function escapeHtml(html: string) {
        const div: HTMLElement = document.createElement("div");
        div.textContent = html;
        return div.innerHTML;
    }

    // Check if there are parameters
    function hasQueryParams(url: string) {
        return url.indexOf("?") !== -1;
    }

    // Custom function to emit toast notifications
    function notify(
        message: string,
        variant: string = "error",
        duration: number = 5000,
    ) {
        const dialog: HTMLDialogElement = document.createElement(
            "dialog",
        ) as HTMLDialogElement;
        const list: HTMLElement = document.createElement("ul") as HTMLElement;
        const listItemOne: HTMLElement = document.createElement(
            "li",
        ) as HTMLElement;
        const listItemTwo: HTMLElement = document.createElement(
            "li",
        ) as HTMLElement;
        const messageElement: HTMLElement = document.createElement(
            "div",
        ) as HTMLElement;
        const titleElement: HTMLElement = document.createElement(
            "span",
        ) as HTMLElement;
        const closeElement: HTMLElement = document.createElement(
            "div",
        ) as HTMLElement;
        const contentElement: HTMLElement = document.createElement(
            "div",
        ) as HTMLElement;
        const prefixElement: HTMLElement = document.createElement(
            "div",
        ) as HTMLElement;
        const textElement: HTMLElement = document.createElement(
            "div",
        ) as HTMLElement;
        const mainElement = document.querySelector<HTMLDialogElement>("main");

        dialog.style.display = "block";
        dialog.classList.add("notification-popup");
        dialog.classList.add(variant);
        listItemOne.classList.add("notification-start");
        messageElement.classList.add("message");
        titleElement.classList.add("title");
        closeElement.classList.add("close");
        contentElement.classList.add("content");
        prefixElement.classList.add("prefix");
        textElement.classList.add("text");

        titleElement.innerHTML = `${escapeHtml(message)}`;
        prefixElement.innerHTML =
            '<load-svg src="/media/icon/chevron-right.svg">' +
            "<style>\n" +
            "    svg  { height: 16px }\n" +
            "    svg  { width: 6px }\n" +
            "    svg  { fill: var(--complex-white) }\n" +
            "  </style></load-svg>";
        textElement.innerHTML = "okay";

        dialog.append(list);
        list.append(listItemOne);
        list.append(listItemTwo);
        listItemOne.append(messageElement);
        messageElement.append(titleElement);
        listItemTwo.append(closeElement);
        closeElement.append(contentElement);
        contentElement.append(prefixElement);
        contentElement.append(textElement);

        mainElement?.prepend(dialog);
        const closeButtons = document.querySelectorAll<HTMLElement>(".close");
        closeButton(closeButtons);

        const notification: Node = dialog.parentNode as Node;
        setTimeout(() => {
            if (notification.contains(dialog)) {
                notification.removeChild?.(dialog);
            } else {
                return;
            }
        }, duration);
    }
}
